import { definePreset } from '@primeng/themes';
import Lara from '@primeng/themes/lara';

export const CorporatePreset = definePreset(Lara, {
  semantic: {
    primary: {
      50: 'var(--secondary-hover)',
      100: 'var(--secondary-click)',
      200: 'var(--primary-200)',
      300: 'var(--primary-300)',
      400: 'var(--primary-400)',
      500: 'var(--hover)',
      600: 'var(--click)',
      700: 'var(--primary-700)',
      800: 'var(--primary-800)',
      900: 'var(--primary)',
      950: 'var(--primary-950)',
    },
    colorScheme: {
      light: {
        primary: {
          color: 'var(--primary)',
          contrastColor: 'var(--corporate-color-one)',
          hoverColor: 'var(--click)',
          activeColor: 'var(--hover)',
        },
        highlight: {
          background: 'var(--secondary-hover)',
          focusBackground: 'var(--secondary-click)',
          color: 'var(--text-color-primary)',
          focusColor: 'var(--text-color-primary)',
        },
      },
    },
  },
});
